<template>
	<div class="sidenav-wrapper" :class="{ open: isSideNavOpen }">
		<nav class="sidenav-comp">
			<PictureImg v-if="logo" class="sidenav__logo" :media="logo" />
			<div class="sidenav-inner">
				<ul class="sidenav__links" v-if="items && items.length > 0">
					<template v-for="(item, index) of items">
						<NavLink
							v-if="item.fields && item.fields.link"
							:key="`sidenav__link__${index}`"
							:fields="item.fields"
						/>
						<SideNavChild
							v-if="item.fields && item.fields.items"
							:key="`sidenav__child__${index}`"
							:fields="item.fields"
						/>
					</template>
				</ul>
			</div>
		</nav>
		<div class="sidenav__backdrop" @click="toggleSideNav"></div>
	</div>
</template>

<script setup>
const store = useAppStore();

const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
	class: { type: String, required: false },
});

const items = computed(() => props.fields?.items || []);
const isSideNavOpen = computed(() => store.isSideNavOpen);
const logo = computed(() => props.fields?.logo?.value);

onMounted(() => {
	document.querySelectorAll(".sidenav__links a.link").forEach((el) => {
		el.addEventListener("click", () => toggleSideNav());
	});
});

function toggleSideNav() {
	store.toggleSideNav();
}

watch(
	() => store.isSideNavOpen,
	(isOpen) => {
		if (isOpen) {
			document.body.classList.add("overflow-hidden");
		} else {
			document.body.classList.remove("overflow-hidden");
		}
	}
);
</script>

<style lang="scss">
.sidenav-comp {
	position: absolute;
	overflow-y: auto;
	left: -100%;
	bottom: 0;
	top: 0;
	width: 100%;
	min-height: 100%;
	max-width: 100%;
	background-color: #e9e9e9;
	z-index: 10;
	transition: left 0.5s, opacity 0.15s;
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: column;
	opacity: 0;
	padding-top: var(--header-height, 54px);

	min-height: 100vh;
	min-height: 100dvh;

	@media (min-width: 768px) {
		min-height: 80vh;
		min-height: 80vh;
	}

	.sidenav-inner {
		width: 100%;
		overflow: hidden;
		flex-shrink: 0;
		padding-top: 24px;
	}

	.sidenav-wrapper.open & {
		left: 0;
		opacity: 1;
	}

	.sidenav__links {
		padding-left: 0;
		width: 100%;
		display: grid;
		gap: 0;
		list-style-type: none !important;
	}

	.sidenav-child__link .link,
	.side-nav-language-switcher__select.link {
		font-size: 20px;
		font-weight: 700;
	}

	.side-nav-language-switcher__select {
		padding: var(--spacing-105, 12px) var(--spacing-4, 32px)
			var(--spacing-105, 12px) var(--spacing-3, 24px);
	}

	.has-child {
		position: relative;

		& > span {
			text-decoration: underline;
			text-underline-offset: var(--spacing-1, 8px);
		}

		.sidenav__links {
			margin-top: 0;
			overflow: hidden;
			gap: 24px;
		}

		&:not(.has-label):not(:first-child) {
			.sidenav__links {
				margin-top: 20px;
			}
		}

		&:not(:last-child) {
			padding-bottom: 20px;
		}
	}

	.picture-img-wrapper {
		position: absolute;
		top: 24px;
		left: 24px;
	}

	.sidenav__logo img {
		border-radius: 0;
		height: 33px;
		padding: 0;
	}

	.sidenav-child__sub-link .link {
		padding-left: 50px;
		font-family: var(--primary-font, sans-serif);
		font-size: 14px;
		font-weight: 400;
		line-height: 150%;
		color: var(--Primary-Colours-Night-Sky, #191a1a);
	}

	.side-nav--bottom {
		.sidenav__links {
			gap: 0;
		}

		.sidenav__links .link {
			font-family: var(--primary-font, sans-serif);
			font-size: 14px;
			font-weight: 400;
			line-height: 150%;
			color: var(--primary-colours-fades-night-sky-50, rgba(25, 26, 26, 0.5));
		}

		svg path {
			fill: var(--primary-colours-fades-night-sky-50, rgba(25, 26, 26, 0.5));
		}
	}
}

.sidenav__backdrop {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background-color: var(--color-black, #000);
	opacity: 0.8;
	z-index: 9;
	display: none;

	.sidenav-wrapper.open & {
		display: block;
	}
}
</style>
